<ul class="nav nav-pills tab-btns mb-3" role="tablist" data-bs-toggle="buttons">
  <li class="nav-item" role="presentation">
    <a
      id="{{ leftButtonId() }}"
      class="nav-link pointer"
      data-bs-toggle="pill"
      role="tab"
      aria-controls="pills-home"
      [class.active]="isActive()"
      (click)="onClickLeft()"
    >
      {{ leftButtonLabel() | translate }}
    </a>
  </li>

  <li class="nav-item ml-0" role="presentation">
    <a
      id="{{ rightButtonId() }}"
      class="nav-link pointer"
      data-bs-toggle="pill"
      role="tab"
      aria-controls="pills-profile"
      [class.active]="!isActive()"
      (click)="onClickRight()"
    >
      {{ rightButtonLabel() | translate }}
    </a>
  </li>
</ul>
